import React from 'react';
import {BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import { Context } from './context';
import Intro from './page/intro/Index';
import Settled from './page/settled/Index';
import JumpToYun from './page/jumpToYun/Index';
import JumpToCrm from './page/jumpToCrm/Index';
import SecurityStaff from './page/securityStaff/Index';

const App = () => {
  const platform = /Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent) ? 'mobile': 'pc'
  return  (
    <Context.Provider value={platform}>
      <Router>
        <Switch>
          <Route exact path='/' component={Intro}/>
          <Route path='/settled' component={Settled}/>
          {/* 合同 */}
          <Route path='/jumpToYun' component={JumpToYun}/>
          {/* 人脉库 */}
          <Route path='/jumpToCrm' component={JumpToCrm}/>
          <Route path='/securityStaff' component={SecurityStaff}/>
          <Redirect push to="/" />
        </Switch>
      </Router>
    </Context.Provider>
  );
}

export default App;
